import { browser } from './_browser-version'

document.addEventListener('DOMContentLoaded', load_menu)
// window.addEventListener('load', load_menu)
//window.addEventListener('resize', load_menu)
//console.log('what is window outer width?', window.outerWidth)

async function load_menu() {
	if (browser.name !== 'ie') {
		window.removeEventListener('load', load_menu)
		//window.removeEventListener('resize', load_menu)

		const menu_module = await import(/* webpackChunkName: "mobile-menu" */ 'mmenu-js')
		const Mmenu = menu_module.default
		// eslint-disable-next-line no-unused-vars
		const heading = document.querySelector('.wp-block-texas-biomed-issue-heading a')

		const menu = new Mmenu(
			document.querySelector('nav.txbri-issue-menu'),
			{
				theme: 'light',
				navbar: {
					add: true,
					title: heading.textContent,
				},
				offCanvas: {
					position: 'right',
				},
				hooks: {
					'close:after': () => {
						setTimeout(() => {
							window.dispatchEvent(new Event('resize'))
						}, 250)
					},
				},
			},
			{
				classNames: {
					selected: 'active',
				},
				counters: {
					add: false,
				},
				iconbar: {
					use: true,
					top: ['<a href="#/"><i class="fa fa-home"></i></a>'],
				},
				offCanvas: {
					page: {
						noSelector: ['#wpadminbar'],
					},
				},
			}
		)

		const api = menu.API
		window.magazineMenu = menu

		//navigator.openPanel(document.querySelector( "#ul" ))

		document.getElementById('main_menu_toggle_js').addEventListener('click', event => {
			event.preventDefault()

			api.open()
		})

		document.getElementById('mm-0').addEventListener('click', event => {
			event.preventDefault()

			api.close()
		})

		document.querySelector('.txbri-issue-menu').classList.remove('hidden')

		// //grab the quick links menu items and add them to the mobile menu
		// const quickLinksListItems = document.querySelectorAll('#menu-quick-links li')
		// const mobileMenu = document.getElementsByClassName('mm-listview')

		// if (quickLinksListItems && mobileMenu) {
		// 	for (let i = 0; i < quickLinksListItems.length; i++) {
		// 		//console.log(quickLinksListItems[i])

		// 		quickLinksListItems[i].classList.add('mobile-quicklink')

		// 		//append this li to the ul
		// 		mobileMenu[0].appendChild(quickLinksListItems[i])
		// 	}
		// }
	}
}

// function has_focus() {
// 	if (window.magazineMenu && window.magazineMenu) {
// 		// window.magazineMenu.API.close()
// 		var sliders = Object.keys(window).filter(function (k) {
// 			return k.indexOf('revapi') == 0
// 		})
// 		if (sliders instanceof Array) {
// 			sliders.forEach(function (slider) {
// 				if (typeof window[slider].revredraw === 'function' && typeof window[slider].revredraw !== 'undefined') {
// 					setTimeout(function () {
// 						window[slider].revredraw()
// 					}, 100)
// 				}
// 			})
// 		}
// 	}
// }

// document.addEventListener('visibilitychange', function () {
// 	if (document.hidden && window.magazineMenu) {
// 		window.magazineMenu.API.close()
// 	}
// })

// window.addEventListener('focus', has_focus)

// window.addEventListener('focusin', has_focus, true)
